import { Observable } from 'rxjs';
import httpService from './httpService';
import { DriverLocation } from '../data/models/driver-location.model';
import { Driver } from '../data/models/driver.model';
import { PagedList } from '../data/models/paged-list.model';
import { DriversByProviderRequest } from '@/data/requests/drivers-by-provider';
import type { SortModel } from '@/data/models/sort-model.model';

class DriverService {
  private readonly apiBaseF1;

  constructor() {
    const { __environment__ } = window as any;
    this.apiBaseF1 = __environment__.REACT_APP_DRIVER_API_F1_URL.trim();
  }

  public getDriverLocation(driverID: number): Observable<DriverLocation> {
    const url = `${this.apiBaseF1}/${driverID}/location`;
    return httpService.getJSON(url);
  }

  public getDriversByProvider(
    request: DriversByProviderRequest,
  ): Observable<PagedList<Driver>> {
    const queryParams = Object.entries(request)
      .filter(([_, value]) => value !== undefined && value !== null)
      .map(([key, value]) => {
        if (key === 'sortModel') {
          return `sort=${(value as SortModel).column}&sortOrder=${(value as SortModel).direction}`;
        } else {
          return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
        }
      })
      .join('&');

    return httpService.getJSON(`${this.apiBaseF1}/optimized?${queryParams}`);
  }
}

const driverService = new DriverService();

export default driverService;
